const messages = {
  name: 'Proveedor |||| Proveedores',
  dialog: {
    title: 'Detalles del Proveedor',
  },
  actions: {
    addProvider: 'Anadir Proveedor',
  },
  filters: {
    providerName: 'Nombre del Proveedor',
    communicationType: 'Tipo de Comunicacion',
  },
  fields: {
    providerName: 'Nombre del Proveedor',
    providerStatus: 'Estado del Proveedor',
    priority: 'Prioridad',
    retries: 'Reintentos',
    communicationType: 'Tipo de Comunicacion',
    uploadFile: 'Subir Archivo de Notificacion Push',
    pushNotificationFile: 'Archivo de notificacion push',
    hostname: 'Servidor',
    port: 'Puerto',
    username: 'Usuario',
    password: 'Contrasena',
    securityType: 'Tipo de Seguridad',
    from: 'De',
    serviceAccountEmail: 'Email de Cuenta de Servicio',
    privateKey: 'Clave Privada',
    userToImpersonate: 'Usuario a Suplantar',
    apiEndpoint: 'Endpoint API',
    apiKey: 'Clave API',
    apiSecret: 'Secreto API',
    apisecret: 'Secreto API',
    customHeaders: 'Cabeceras Personalizadas',
    senderId: 'ID de Remitente',
    businessPhoneNumber: 'Numero de Telefono Empresarial',
    botToken: 'Token del Bot',
    viberAuthToken: 'Auth Token de Viber',
    viberSenderName: 'Nombre del remitente',
    lineChannelAccessToken: 'Channel Access Token',
    phoneNumberId: 'ID del Numero de Telefono',
    wabaId: 'ID de WABA',
    accessToken: 'Token de Acceso',
    graphApiVersion: 'Version de Graph API',
    metaBusinessPhoneNumber: 'Numero de Telefono Empresarial',
    whatsAppProviderType: 'Transporte de WhatsApp',
    webhookUrl: 'URL del webhook',
  },
  rail: {
    general: 'General',
    email: 'Email',
    messaging: 'Mensajeria',
    push: 'Push',
    teamChat: 'Team chat',
  },
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
  },
  email: {
    variants: {
      basicAuth: 'Proveedor SMTP via Basic Auth',
      oauth2: 'Proveedor SMTP via Oauth2',
      api: 'SendGrid Api',
      none: 'Ninguno',
    },
  },
  whatsApp: {
    transport: 'Transporte de WhatsApp',
    transportHelper:
      'Cada proveedor usa un transporte. Crea otro proveedor para habilitar el otro.',
    variants: {
      twilio: 'Twilio',
      meta: 'Meta WhatsApp Cloud API',
    },
  },
  sections: {
    basicInfo: 'Informacion Basica',
    email: 'Proveedor de Email',
    sms: 'Proveedor de SMS',
    whatsApp: 'Proveedor de WhatsApp',
    telegram: 'Proveedor de Telegram',
    viber: 'Proveedor de Viber',
    line: 'Proveedor de LINE',
    push: 'Notificacion Push',
    teamChat: 'Team chat',
  },
  help: {
    basic: 'Configuracion basica del proveedor: nombre, estado y politica de entrega.',
    email: 'Configura como se envia el email saliente.',
    sms: 'Activa para configurar el envio de SMS.',
    whatsApp: 'Activa para configurar el envio de WhatsApp.',
    telegram: 'Activa para configurar el envio de Telegram.',
    viber: 'Activa para configurar el envio por bot de Viber.',
    viberSenderName: 'Se muestra como remitente del mensaje en Viber (max 28 caracteres).',
    line: 'Activa para configurar el envio por bot de LINE.',
    push: 'Activa para configurar las notificaciones push web.',
    teamChat: 'Activa para enviar a esta plataforma por su webhook entrante.',
    teamChatWebhook: 'URL del webhook entrante de esta plataforma (se guarda como secreto).',
    createBanner: 'Crea un nuevo proveedor para tu cuenta de Notify.',
    editBanner: 'Actualiza la configuracion del proveedor.',
    sensitiveOnEdit: 'Deja vacio para conservar el valor existente.',
  },
  push: {
    existingFileNotice: 'Ya existe un archivo de notificaciones push. Activa "Reemplazar archivo existente" para subir uno nuevo.',
    replaceToggle: 'Reemplazar archivo existente',
  },
  create: {
    title: 'Crear Proveedor',
  },
  edit: {
    title: 'Editar Proveedor',
  },
  delete: {
    title: 'Eliminar proveedor "%{recordName}"',
    content: 'Seguro que quieres eliminar este proveedor? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Proveedor creado correctamente',
    updated: 'Proveedor actualizado correctamente',
    deleted: 'Proveedor eliminado correctamente',
  },
  validation: {
    required: '%{field} es obligatorio',
    maxLength: '%{field} debe tener como maximo %{max} caracteres',
    minValue: '%{field} debe ser mayor o igual a %{min}',
    positive: '%{field} debe ser un numero positivo',
  },
};

export default messages;
